import "fullscreen-polyfill";
import { TranscriptsPlayerWrapper } from "@circle-react-uikit/TranscriptsPlayer/TranscriptsPlayerWrapper";
import { PunditUserContextProvider } from "@circle-react/contexts/punditUserContext";
import { QueryClientProvider } from "@circle-react/providers/QueryClient";
import { CompassProvider } from "@circleco/compass/context/CompassProvider";

import { ToastProvider } from "@/react/components/SettingsApp/CompassCompat/Toast";

import type { TranscriptsPlayerProps } from "./TranscriptsPlayerComponent";

export const TranscriptsPlayer = (props: TranscriptsPlayerProps) => (
  <CompassProvider>
    <QueryClientProvider>
      <PunditUserContextProvider>
        <ToastProvider>
          <TranscriptsPlayerWrapper {...props} />
        </ToastProvider>
      </PunditUserContextProvider>
    </QueryClientProvider>
  </CompassProvider>
);
